<template v-cloak>
  <end-time v-if="end_time" />

  <!-- <div v-else class="questions_all"> -->
  <div v-else class="questions_all" :class="{ 'is-blurred': isBlurred }">
    <vtake-interval-photos
      :disabled="!hasAnticheating"
      :allow-pass="true"
      :screen-by-start="true"
      @set_photo="set_photo"
      @on_error="screenshots_error"
    >
      <div slot="enabled">
        <floating-block class-name="timer" @changeFixed="fixedTimer = $event">
          <timer
            questions="all"
            :inited="time_inited"
            :current="time_current"
            :count-questions="questions.length"
            :stop_time="stop_time"
            @end_time="timeout"
          >
            <div v-if="fixedTimer && test.company && !!test.company.logo" class="logo">
              <img :src="test.company.logo" alt="vcv" />
            </div>

            <span v-else class="timer-label">{{ $tr('interview.tests.all.questions.timer') }}</span>
          </timer>
        </floating-block>

        <div class="questions">
          <div v-for="(question, k) in questions" :key="question.id" class="question">
            <div class="text">
              <div class="question-header-wrap">
                <div class="number">{{ k + 1 }}.</div>
                &nbsp;
                <div class="question_header" v-html="question.body"></div>
              </div>

              <div
                v-if="question.is_graph_enabled && question.chart_config !== null && question.chart_config.length > 0"
                class="questions_one__charts"
              >
                <div v-for="(config, indexChart) in question.chart_config" :key="indexChart">
                  <!-- <pre>{{ getApexOptions({ questionId: question.id, indexChart }) }}</pre> -->
                  <apexchart
                    v-if="getApexOptions({ questionId: question.id, indexChart }) !== null"
                    :type="config.type"
                    :series="getApexOptions({ questionId: question.id, indexChart }).series"
                    :options="getApexOptions({ questionId: question.id, indexChart })"
                    class="questions_one__chart"
                  />
                </div>
              </div>

              <div v-if="media(question)" class="media-all">
                <question-media
                  :media="media(question)"
                  :is_separate_page="!!time_inited"
                  :is_disabled="!!time_inited"
                  :time_inited="time_inited"
                  @stop_timer="stop_timer"
                  @start_timer="start_timer"
                  @start_media="start_media(question.id)"
                />
              </div>

              <component
                :is="question.type"
                :token="token"
                :index="k + 1"
                :data="question.answers"
                :is_answer_paste_disabled="is_answer_paste_disabled"
                @loading="set_loading"
                @update="update_answer($event, question.id)"
              />
            </div>
          </div>
        </div>

        <div class="but-wrapper">
          <vbutton
            class="but"
            :text="$tr('interview.tests.all.questions.button.end')"
            :disabled="!can_save || loading"
            :loading="loading"
            @click="save"
          />
        </div>
      </div>
    </vtake-interval-photos>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import { dataURItoBlob } from '@/_helpers/utils.js';
import choice from '@/routes_new/outer/interview/landing/tests/test/components/answers_choice';
import multichoice from '@/routes_new/outer/interview/landing/tests/test/components/answers_multichoice';
import value from '@/routes_new/outer/interview/landing/tests/test/components/answers_value';
import file from '@/routes_new/outer/interview/landing/tests/test/components/answers_file';
import timer from '@/routes_new/outer/interview/landing/tests/test/components/timer';
import EndTime from '@/routes_new/outer/interview/landing/tests/test/components/end_time';
import FloatingBlock from '@/components_new/floating-block';
import QuestionMedia from '@/routes_new/outer/interview/landing/tests/test/components/question_media';
import ScreenshotsProhibit from '@/mixins/ScreenshotsProhibit.js';

export default {
  name: 'QuestionsAll',

  components: {
    FloatingBlock,
    value,
    file,
    choice,
    multichoice,
    timer,
    EndTime,
    QuestionMedia
  },

  mixins: [ScreenshotsProhibit],

  props: ['hasAnticheating'],

  data() {
    return {
      end_time: false,
      fixedTimer: false,
      stop_time: false,
      isSaving: false
    };
  },

  computed: {
    ...mapGetters('tests_test', {
      answers: 'questions/candidate_answers',
      questions: 'questions/list',
      loading: 'questions/loading',
      test: 'item',
      token: 'token'
    }),

    ...mapGetters('questions', ['getApexOptions']),

    is_answer_paste_disabled() {
      return this.test.is_answer_paste_disabled;
    },

    time_current() {
      return this.test.remaining_time;
    },

    time_inited() {
      return this.test.time_limit;
    },

    /* считаем 10% от оставшегося времени с округлением */
    can_save() {
      return this.answers.length === this.questions.length;
    }
  },

  watch: {
    answers(val) {
      if (val && val.length) {
        window.onbeforeunload = function (e) {
          return e;
        };
      } else {
        window.onbeforeunload = null;
      }
    }
  },

  methods: {
    ...mapMutations('tests_test', { set_loading: 'questions/set_loading' }),

    save() {
      if (!this.isSaving) {
        this.isSaving = true;
        // questionId = null отправляем потому, что показываем все вопросы на странице
        this.$store
          .dispatch('tests_test/questions/save', null)
          .then(async () => {
            await this.$emit('end');
          })
          .finally(() => {
            this.isSaving = false;
          });
      }
    },

    media(question) {
      return question ? question.media : null;
    },

    screenshots_error() {
      this.$emit('screenshots_error');
    },

    update_answer(v, id) {
      this.$store.commit('tests_test/questions/update_candidate_answers', { id, v });
    },

    timeout() {
      // questionId = null отправляем потому, что показываем все вопросы на странице
      this.$store
        .dispatch('tests_test/questions/save', null)
        .then(async () => {
          await this.$emit('timeout');
          this.end_time = true;
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    start_media(id) {
      this.$store.dispatch('tests_test/question/start_media', id);
    },

    stop_timer() {
      this.stop_time = true;
    },

    start_timer() {
      if (this.stop_time) {
        this.stop_time = false;
      }
    },

    // sentryDisplay(data) {
    //   if (this.$raven) {
    //     this.$raven.captureException(new Error('Anticheating-error'), {
    //       extra: data
    //     });
    //   }
    // },

    set_photo(screenshot) {
      if (this.end_time) return;
      const data = new FormData();
      data.append('picture', dataURItoBlob(screenshot));
      window.foo = data;
      axios.post(`/public/v2/interviews/${this.token}/test/screenshots`, data);
      if (!screenshot) {
        console.log('screenshot problem');
        // this.sentryDisplay({
        //   videoId: this.videoId,
        //   currentQuestion: this.currentQuestion,
        //   interview: this.interview
        // });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

[v-cloak] {
  display: none;
}

.questions_all {
  ::v-deep {
    .floating-block.timer {
      margin-top: 0;
      margin-bottom: 36px;
    }
  }

  &.is-blurred {
    filter: blur(15px);
  }
}

.question {
  margin-bottom: 36px;
  display: flex;

  .question-header-wrap {
    display: flex;
    align-items: flex-start;
  }

  .number {
    color: #9faab6;
    line-height: 20px;
  }

  .text {
    width: 100%;

    .question_header {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 12px;
    }

    .question_header p {
      margin-top: 0;
    }

    .question_header ol,
    .question_header ul {
      padding-left: 17px;
    }
  }
}

.but-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.timer-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logo {
  height: 60px;
  max-height: 60px;
  min-height: 60px;

  img {
    height: 100%;
  }
}

.questions {
  .question {
    ::v-deep img {
      width: 100%;
      min-width: 350px;
    }
  }
}

.media-all {
  margin-bottom: 20px;
}

::v-deep {
  // table
  .tableWrapper {
    overflow-x: auto;
  }

  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    tr {
      height: auto !important;
    }

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
      @include mixin-text-main;

      > * {
        margin-bottom: 0;
      }

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: '';
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }

    p {
      margin: 0;
    }
  }
}
</style>
